import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M15.615 21.292H9.049C8.176 21.292 7.466 20.582 7.466 19.709L6.385 8.292C6.371 8.152 6.418 8.013 6.513 7.909C6.608 7.805 6.742 7.745 6.883 7.745H17.781C17.922 7.745 18.056 7.805 18.151 7.909C18.246 8.013 18.292 8.152 18.279 8.292L17.196 19.756C17.198 20.582 16.488 21.292 15.615 21.292V21.292ZM7.432 8.745L8.464 19.662C8.466 20.03 8.728 20.292 9.049 20.292H15.615C15.936 20.292 16.198 20.03 16.198 19.709L17.231 8.745H7.432V8.745Z"
      fill="currentColor"
    />
    <path
      d="M5.65689 7.36694C5.42789 7.32094 5.25589 7.11994 5.25489 6.87794C5.25289 6.00394 5.96189 5.29294 6.83489 5.28994L17.6499 5.26294C18.5259 5.26694 19.2359 5.96994 19.2379 6.84194C19.2389 7.11794 19.0159 7.34194 18.7389 7.34294C18.4599 7.34194 18.2379 7.12094 18.2369 6.84394C18.2359 6.52294 17.9679 6.26294 17.6529 6.26294L6.83689 6.29094C6.51589 6.29094 6.25489 6.55394 6.25489 6.87494C6.25589 7.15094 6.03189 7.37594 5.75589 7.37594C5.72289 7.37694 5.68889 7.37294 5.65689 7.36694V7.36694Z"
      fill="currentColor"
    />
    <path
      d="M10.4899 5.68402C10.2619 5.63802 10.0889 5.43702 10.0889 5.19502L10.0869 4.56402C10.0859 4.14302 10.2499 3.74502 10.5479 3.44402C10.8469 3.14402 11.2439 2.97802 11.6659 2.97602L12.8159 2.97302C13.6859 2.97402 14.4009 3.68002 14.4039 4.55202L14.4049 5.18302C14.4059 5.45902 14.1819 5.68402 13.9059 5.68402C13.6359 5.68402 13.4059 5.46202 13.4049 5.18502L13.4039 4.55402C13.4029 4.23302 13.1439 3.97202 12.8189 3.97302L11.6689 3.97702C11.5139 3.97702 11.3679 4.03802 11.2579 4.14902C11.1479 4.26002 11.0869 4.40702 11.0879 4.56102L11.0899 5.19202C11.0899 5.46802 10.8659 5.69302 10.5899 5.69402C10.5559 5.69402 10.5219 5.69002 10.4899 5.68402V5.68402Z"
      fill="currentColor"
    />
    <path
      d="M12.333 18.448C12.057 18.448 11.833 18.224 11.833 17.948V10.917C11.833 10.641 12.057 10.417 12.333 10.417C12.609 10.417 12.833 10.641 12.833 10.917V17.949C12.833 18.225 12.609 18.448 12.333 18.448Z"
      fill="currentColor"
    />
    <path
      d="M14.395 18.448C14.378 18.448 14.363 18.447 14.346 18.446C14.071 18.42 13.869 18.175 13.896 17.9L14.573 10.868C14.6 10.592 14.848 10.4 15.119 10.418C15.394 10.444 15.596 10.689 15.569 10.963L14.892 17.995C14.866 18.255 14.648 18.448 14.395 18.448V18.448Z"
      fill="currentColor"
    />
    <path
      d="M10.2929 18.448C10.0379 18.448 9.82094 18.255 9.79594 17.996L9.11994 10.964C9.09394 10.689 9.29494 10.445 9.56994 10.419C9.83794 10.395 10.0889 10.593 10.1149 10.869L10.7919 17.9C10.8179 18.174 10.6169 18.42 10.3419 18.446C10.3259 18.447 10.3099 18.448 10.2929 18.448V18.448Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'TrashBin');

export default Icon;
